import { get, post } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';

const API_NAME = 'AdminAPI';
const BASE_PATH = '/api/v1/admin/bulk-download';

const isLocalDev = process.env.REACT_APP_LOCAL_DEV || false;

// Helper function to get auth headers
async function getAuthHeaders() {
  // Skip authentication in local development mode
  if (isLocalDev) {
    return {};
  }

  const session = await fetchAuthSession();
  return {
    Authorization: `Bearer ${session.tokens?.idToken?.toString()}`
  };
}

// Initiate a bulk download job
// imageSize: 'full', 'medium', or 'small'
// photoIds: optional array of photo IDs (if not provided, downloads all photos)
export async function initiateBulkDownload(imageSize, photoIds = null) {
  try {
    const headers = await getAuthHeaders();

    const body = { imageSize };
    if (photoIds && photoIds.length > 0) {
      body.photoIds = photoIds;
    }

    const restOperation = post({
      apiName: API_NAME,
      path: BASE_PATH,
      options: {
        headers: {
          ...headers,
          'Content-Type': 'application/json'
        },
        body
      }
    });

    const response = await restOperation.response;
    const data = await response.body.json();

    return data;
  } catch (error) {
    console.error('Error initiating bulk download:', error);
    throw error;
  }
}

// Get the status of a bulk download job
export async function getBulkDownloadStatus(jobId) {
  try {
    const headers = await getAuthHeaders();

    const restOperation = get({
      apiName: API_NAME,
      path: `${BASE_PATH}/${jobId}/status`,
      options: { headers }
    });

    const response = await restOperation.response;
    const data = await response.body.json();

    return data;
  } catch (error) {
    console.error('Error getting bulk download status:', error);
    throw error;
  }
}

// Get the download URL for a completed bulk download job
export async function getBulkDownloadUrl(jobId) {
  try {
    const headers = await getAuthHeaders();

    const restOperation = get({
      apiName: API_NAME,
      path: `${BASE_PATH}/${jobId}/download-url`,
      options: { headers }
    });

    const response = await restOperation.response;
    const data = await response.body.json();

    return data;
  } catch (error) {
    console.error('Error getting bulk download URL:', error);
    throw error;
  }
}
